import React from 'react';
import Modal from 'components/UI/DialogModal';
import {  Grid, Skeleton, Stack, TableCell, Typography } from '@mui/material';
import MuiButton from 'components/UI/MuiButton';
import List from 'components/UI/List';
import {  ClientsCellsNoActions } from 'framework/clients';
import { Feature } from 'models/api';
import useFetchSection from 'hooks/useFetchSection';
import {  getSubscription } from 'framework/subscription';
import { IClientsOfResellers } from 'models/subscription';
import EmptyContent from 'components/EmptyContent';
import BlindsClosedIcon from "@mui/icons-material/BlindsClosed";


interface Props {
  open: boolean;
  title:string;
  feature: Feature;
  id:number;
  onClose: () => void;
}




const ViewClientsModal: React.FC<Props> = ({ open,feature, id,  title, onClose }) => {

  //https://vrapi.emergingsystems.us/api/Subscriptions?resellerId=1

  const {
    loading,
    data: Clients,
    error,
    revalidate,
  } = useFetchSection({
    fetchData: () => getSubscription({resellerId:id}),
    fetchPermission: async () => null,
    section: "Clients of Resellers",
  
  });

  if (loading) return null;


  const getBodyCells = (row: IClientsOfResellers) => {
    let cells = Object.keys(row).map((key: string, i: number) => {
      if (key === "clientName")
        return {
          id: "clientName",
          element: (
            <TableCell align={"left"} key={i}>
              <Typography variant="body2">{row?.clientName}</Typography>
            </TableCell>
          ),
        };
      if (key === "serviceName")
        return {
          id: "serviceName",
          element: (
            <TableCell align={"left"} key={i}>
              <Typography variant="body2">{row?.serviceName}</Typography>
            </TableCell>
          ),
        };

      if (key === "planName")
        return {
          id: "planName",
          element: (
            <TableCell align={"left"} key={i}>
              <Typography variant="body2">{row?.planName}</Typography>
            </TableCell>
          ),
        };

        if (key === "startDate"){
          const date=new Date(row?.startDate)
          return {
            id: "startDate",
            element: (
              <TableCell align={"left"} key={i}>
                <Typography variant="body2">{date.toDateString()}</Typography>
              </TableCell>
            ),
          };
        }
          


          if (key === "renewalDate"){
            const date=new Date(row?.renewalDate)
            return {
              id: "renewalDate",
              element: (
                <TableCell align={"left"} key={i}>
                  <Typography variant="body2">{date.toDateString()}</Typography>
                </TableCell>
              ),
            };
          }
          

            if (key === "status")
              return {
                id: "status",
                element: (
                  <TableCell align={"left"} key={i}>
                    <Typography variant="body2">{row?.status}</Typography>
                  </TableCell>
                ),
              };
    });
    return cells;
  };

  return (<>

    <Modal
      open={open}
      onClose={onClose}
      title={title}
      maxWidth="lg"
      
      children={<Stack spacing={2} p={2} >
          { Clients!.length > 0 &&  <List
            headCells={ClientsCellsNoActions}
            data={Clients!}
            getBodyCells={getBodyCells}
            feature={feature}
            canEdit={false}
          /> }

        {(!Clients || Clients.length === 0) &&
           <EmptyContent
             icon={<BlindsClosedIcon sx={{ fontSize: "3.5rem " }} />}
             header={"No Client Subscriptions"}
             message={""}
           />
         }

      </Stack>}
      
    />
  </>
  );
};

export default ViewClientsModal;
